import { useQuery } from '@hooks/reactQuery';

import { getChangeMonitoringStatusesHistory } from '@api/manageNetworkElementConfigurations';

import { extractQueryParams } from '@utils/common';

import {
	IChangeMonitoringStatusesHistoryDTO,
} from '@interfaces/networkElementConfigurations/dto/networkElementConfigurationsDTO';
import {
	IChangeMonitoringStatusesHistory,
} from '@interfaces/networkElementConfigurations/networkElementConfigurations';

import { refetchOptions } from '@constants/common';
import { NETWORK_ELEMENT_CHANGE_MONITORING_STATUSES_HISTORY } from '@constants/queryKeys';

interface IUseQueryChangeMonitoringReturn {
	isLoadingStatusesHistory: boolean;
	statusesHistory: IChangeMonitoringStatusesHistory[];
	countOfRecords: number;
}

export const useQueryChangeMonitoringStatusesHistory = (
	params: IChangeMonitoringStatusesHistoryDTO,
): IUseQueryChangeMonitoringReturn => {
	const { data, isInitialLoading: isLoading } = useQuery({
		queryKey: [NETWORK_ELEMENT_CHANGE_MONITORING_STATUSES_HISTORY, params],
		queryFn: extractQueryParams(getChangeMonitoringStatusesHistory),
		enabled: [!!params.updateId],
		...refetchOptions,
	});

	return {
		isLoadingStatusesHistory: isLoading,
		statusesHistory: data?.items || [],
		countOfRecords: data?.count || 0,
	};
};
